import Link from "next/link";
import ItemFooterCommentaires from "./ItemFooterCommentaires";
import FormCommentaires from "./FormCommentaires";
import { textFormat, convertHtml } from "../../tools/helper";
import Image from "next/image";
import { useEffect, useState, memo } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import userStore from "../../store/userStore";
import ItemCommentairesMedia from "./ItemCommentairesMedia";
import {
  MdCake,
  MdLock,
  MdLockOutline,
  MdPhoneAndroid,
  MdWarning,
} from "react-icons/md";
import { FaChevronDown } from "react-icons/fa";

function ItemCommentaires({ passRefresh, handleChange, ...props }) {
  var pointsMinComs = process.env.NEXT_PUBLIC_POINTS_MIN_COMS;
  const [showFormReponse, setShowFormReponse] = useState(false);
  const [display, setDisplay] = useState(
    props.com.points < pointsMinComs ? 0 : 1
  );

  useEffect(() => {
    if (props.com.points < pointsMinComs && !display) {
      setTexte("");
    } else setTexte(props.com.texte);
  }, [props.com.points, display, pointsMinComs]);

  const [loading, setLoading] = useState(false); // pour le form editer
  const [showFormEdit, setShowFormEdit] = useState(false); // pour le form editer
  const [texte, setTexte] = useState(props.com.texte);
  const [texteFormModifier, setTexteFormModifier] = useState(
    convertHtml(props.com.texte)
  ); // pour le form editer
  const [nsfw, setNsfw] = useState(props.com.nsfw); // pour le form editer

  const modifier = async () => {
    setLoading(true);

    var bodyFormData = new FormData();
    bodyFormData.append("token", props.userTk);
    bodyFormData.append("texte", texteFormModifier);
    bodyFormData.append("nsfw", nsfw);
    bodyFormData.append("id", props.com.id);

    const options = {
      headers: {
        "Content-Type": "multipart/form-data",
        // "User-Agent": "Choualbox Next",
      },
    };

    axios
      .post(
        process.env.NEXT_PUBLIC_API_URL + "/api/commentaires/modifier",
        bodyFormData,
        options
      )
      .catch(function (error) {
        toast("Erreur de chargement", {
          type: "error",
        });
        setLoading(false);
      })
      .then((response) => {
        if (response.data.status === 200) {
          passRefresh(true); // refresh

          toast("Commentaire modifié avec succès.", {
            type: "success",
          });

          setShowFormEdit(false);
        } else {
          toast(response.data.message, {
            type: "error",
          });
        }

        setLoading(false);
      });
  };

  const comToHighlight = (id) => {
    const com = document.getElementById("comitemid" + id);
    com.scrollIntoView({ behavior: "smooth", block: "center" });
    com.classList.add("highlight_commentaire");
    setTimeout(() => {
      com.classList.remove("highlight_commentaire");
    }, 700);
  };

  return (
    <div
      className={`text-base-content mb-4 ${
        props.com.id_rep > 0 && !props.com.contexte_permalink ? "ml-10" : null
      }`}
      key={props.com.id}
      id={`comitemid${props.com.id}`}
    >
      <a name={"comid" + props.com.id} />
      <div className="flex">
        <div
          className={`relative flex justify-center ${
            props.com.id_rep > 0 && !props.com.contexte_permalink
              ? "w-7"
              : "w-10"
          } `}
        >
          {props.com.hidden == 0 ? (
            <>
              {/* {props.com.is_birthday ? (
                <>
                  <svg
                    className="absolute shadow z-10 -mt-3 w-4 h-4 text-orange-500 bg-yellow-100 rounded-full"
                    viewBox="0 0 24 24"
                  >
                    <title
                      id={props.com.permalink_rand}
                    >{`C'est l'anniversaire de ${props.com.membre_pseudo} !`}</title>
                    <path
                      fill="currentColor"
                      d="M5 16L3 5L8.5 10L12 4L15.5 10L21 5L19 16H5M19 19C19 19.6 18.6 20 18 20H6C5.4 20 5 19.6 5 19V18H19V19Z"
                    />
                  </svg>
                </>
              ) : null} */}

              <Link
                href={"/blog/" + props.com.membre_permalink}
                className={`${
                  props.com.id_rep && !props.com.contexte_permalink > 0
                    ? "w-7 h-7"
                    : "w-10 h-10"
                }`}
              >
                <img
                  src={props.com.membre_avatar}
                  alt={props.com.membre_pseudo}
                  className={`rounded-full ${
                    props.com.id_rep && !props.com.contexte_permalink > 0
                      ? "w-7 h-7"
                      : "w-10 h-10"
                  } ${props.com.points < pointsMinComs && "opacity-50"} `}
                  preload="none"
                />
              </Link>
            </>
          ) : (
            <></>
          )}
        </div>
        <div className="flex-1 ">
          <div className="pl-2">
            {props.com.hidden == 0 && (
              <div className="flex items-center mb-2">
                <Link
                  href={`/blog/${props.com.membre_permalink}`}
                  className={`text-xs hover:underline ${
                    props.com.is_the_membre
                      ? "bg-user text-user-content"
                      : props.com.is_op
                      ? "bg-op text-op-content"
                      : "text-primary"
                  }
                  ${props.com.points < pointsMinComs && "opacity-50"} `}
                >
                  {props.com.membre_pseudo}
                </Link>
                {props.com.is_birthday ? (
                  <>
                    <div
                      className="bg-purple-500 ml-1 w-4 h-4 flex items-center justify-center rounded-full"
                      title={
                        props.com.membre_pseudo + " fête son anniversaire !"
                      }
                    >
                      <MdCake className="w-3 h-3 text-white" />
                    </div>
                  </>
                ) : null}
                {props.com.posted_from == "app" && props.com.anonyme == 0 ? (
                  <a
                    href="https://bit.ly/3CiFOCh"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    className=""
                    title="Posté depuis l'application mobile Android"
                  >
                    <MdPhoneAndroid className="ml-1 w-3 h-3" />
                  </a>
                ) : null}
                {props.com.is_groupe_admin && props.com.anonyme == 0 ? (
                  <div
                    className="inline-block ml-1 text-xxs leading-4 px-1 bg-admin text-admin-content rounded-full"
                    title="Admin"
                  >
                    a
                  </div>
                ) : props.com.is_groupe_moderator && props.com.anonyme == 0 ? (
                  <div
                    className="inline-block ml-1 text-xxs leading-4 px-1 bg-moderator text-moderator-content rounded-full"
                    title="Modérateur"
                  >
                    m
                  </div>
                ) : null}
                {props.com.membre_groupe_icone &&
                props.com.membre_groupe_icone.icone ? (
                  <img
                    src={props.com.membre_groupe_icone.icone}
                    alt={props.com.membre_groupe_icone.description}
                    className="ml-1 w-4 h-4 rounded-full"
                    title={props.com.membre_groupe_icone.description}
                    preload="false"
                    lazy="true"
                  />
                ) : null}
                <div
                  className={`text-base-content text-xs ml-3 ${
                    props.com.points < pointsMinComs && "opacity-50"
                  }`}
                >
                  {props.com.date}
                </div>

                <div className="grow"></div>
                {props.com.id_rep == 0 && !props.com.contexte_permalink ? (
                  <>
                    <button
                      onClick={() =>
                        handleChange([...props.reduire, props.com.id])
                      }
                      className="text-base-content text-xs w-6 h-4 text-center flex items-center justify-end cursor-pointer"
                      aria-label="Réduire"
                    >
                      <FaChevronDown className="w-3 h-3" />
                    </button>
                  </>
                ) : null}
              </div>
            )}
            <div>
              {props.com.hidden == 0 &&
              props.com.points < pointsMinComs &&
              props.com.desactiver == 0 ? (
                <>
                  <div className="opacity-70 inline text-sm">
                    Ce commentaire a reçu beaucoup de votes négatifs
                  </div>
                  {display ? (
                    <>
                      <button
                        className="inline-block ml-2 text-sm cursor-pointer"
                        onClick={() => setDisplay(0)}
                        aria-label="Masquer"
                      >
                        Masquer
                      </button>
                      <div className="mb-2"></div>
                    </>
                  ) : (
                    <button
                      className="inline-block ml-2 text-sm cursor-pointer"
                      onClick={() => setDisplay(1)}
                      aria-label="Afficher"
                    >
                      Afficher
                    </button>
                  )}
                </>
              ) : null}
              {props.com.id_rep > 0 && props.com.hidden == 0 && display ? (
                <div className="inline-block">
                  <button
                    onClick={() => {
                      comToHighlight(props.com.id_rep);
                    }}
                    className="flex items-center text-primary text-sm hover:underline cursor-pointer"
                  >
                    @{props.com.pseudo_rep}
                  </button>
                </div>
              ) : null}
              {props.com.texte && !showFormEdit ? (
                <>
                  <p
                    className={`text-sm super-break-words block`}
                    dangerouslySetInnerHTML={{
                      __html: textFormat({ html: true, text: texte }),
                    }}
                  ></p>
                </>
              ) : null}
              {showFormEdit && (
                <div className={`${loading && "opacity-50"}`}>
                  <textarea
                    placeholder="Texte..."
                    className="w-full text-sm text-base-content bg-base-100  border border-base-200 p-2 rounded"
                    onChange={(e) => {
                      setTexteFormModifier(e.target.value);
                    }}
                    value={texteFormModifier}
                  />
                  <div className="flex">
                    <button
                      onClick={() => {
                        nsfw == 0 ? setNsfw(1) : setNsfw(0);
                      }}
                      className={` flex items-center w-12 h-8 rounded cursor-pointer ${
                        nsfw == 1
                          ? "bg-pink-500 dark:bg-pink-500"
                          : "bg-base-200"
                      }`}
                    >
                      <div className="text-xs font-semibold text-base-content m-auto">
                        NSFW
                      </div>
                    </button>

                    <div className="grow"></div>
                    <div className="flex">
                      <button
                        onClick={() => setShowFormEdit(false)}
                        className="mr-2 text-xs text-base-content/50 cursor-pointer"
                      >
                        <div>Annuler</div>
                      </button>
                      <input
                        type="submit"
                        value="Modifier"
                        className="btn btn-sm btn-primary no-animation"
                        onClick={() => modifier()}
                      />
                    </div>
                  </div>
                </div>
              )}
              {display ? <ItemCommentairesMedia com={props.com} /> : null}
              {props.com.nsfw == 1 && props.com.hidden == 0 ? (
                <div className="text-xxs text-pink-500 mt-3">NSFW</div>
              ) : null}
            </div>
            {props.com.hidden == 0 && display ? (
              <>
                <ItemFooterCommentaires
                  userTk={props.userTk ? props.userTk : null}
                  item={props.com}
                  module="commentaires"
                  passShowFormReponse={(e) =>
                    setShowFormReponse(!showFormReponse)
                  }
                  passShowFormEdit={(e) => setShowFormEdit(e)}
                />
              </>
            ) : null}
            {showFormReponse && (
              <>
                {/* <div className="flex items-center text-base-content text-xs hover:bg-base-200">
                  <ArrowUturnUpIcon className="w-3 h-3 mr-1" />@
                  {props.com.membre_pseudo}
                </div> */}
                {(props.boxClosed && props.boxClosed == 1) ||
                (props?.com?.contexte_closed &&
                  props.com.contexte_closed == 1) ? (
                  <div className="alert my-2">
                    <MdLockOutline />
                    Les commentaires sont désactivés sur cette box
                  </div>
                ) : (
                  <FormCommentaires
                    userTk={props.userTk ? props.userTk : null}
                    id_reponse={props.com.id}
                    pseudo_reponse={props.com.membre_pseudo}
                    passHideReponseForm={(e) => {
                      setShowFormReponse(false);
                    }}
                    id_arbre={
                      props.com.id_rep == 0 ? props.com.id : props.com.id_arbre
                    }
                    passRefresh={() => {
                      passRefresh(true);
                    }}
                  />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(ItemCommentaires);
